module.exports = __webpack_public_path__ + "img/product1.47881c87.png";